import { render } from "./ReminderDetails.vue?vue&type=template&id=48388b28&scoped=true"
import script from "./ReminderDetails.vue?vue&type=script&lang=js"
export * from "./ReminderDetails.vue?vue&type=script&lang=js"

import "./ReminderDetails.vue?vue&type=style&index=0&id=48388b28&scoped=true&lang=css"

import exportComponent from "/home/travelcrm/travel-crm-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48388b28"]])

export default __exports__